import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import AnalyticsJFThreeLogRq from '@domain/rq/analytics/AnalyticsJFThreeLogRq';

const termsPrefix = '/terms';

export default interface AnalyticsRepo {
  // 데이터 분석 - 잡픞렉스 로그인 관련 데이터 분석용
  fetchAnalyticsJFThreeLogin(rq: AnalyticsJFThreeLogRq): Promise<AxiosResponse>;
}

export class RemoteAnalyticsRepo implements AnalyticsRepo {
  fetchAnalyticsJFThreeLogin(rq: AnalyticsJFThreeLogRq) {
    return axios.post(`/analytics/jf3-apply`, rq);
  }
}
